import { render } from "./TeatcherTable.vue?vue&type=template&id=5a9e073e&scoped=true"
import script from "./TeatcherTable.vue?vue&type=script&lang=js"
export * from "./TeatcherTable.vue?vue&type=script&lang=js"

import "./TeatcherTable.vue?vue&type=style&index=0&id=5a9e073e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9e073e"]])

export default __exports__